import styled from "styled-components";

export const DialogOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  animation: fadeIn 0.2s ease;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

export const DialogContainer = styled.div`
  background: ${props => props.theme.card};
  border-radius: 12px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  width: 90%;
  max-width: 480px;
  overflow: hidden;
  animation: slideUp 0.3s ease;
  border: 1px solid ${props => props.theme.border};

  @keyframes slideUp {
    from {
      transform: translateY(20px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
`;

export const DialogHeader = styled.div`
  padding: 24px 24px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid ${props => props.theme.border};

  .header-content {
    display: flex;
    align-items: center;
    gap: 12px;

    .icon {
      font-size: 24px;
      color: ${props => {
        switch(props.$type) {
          case 'danger': return '#ef4444';
          case 'warning': return '#f59e0b';
          default: return '#3b82f6';
        }
      }};
    }

    h3 {
      margin: 0;
      font-size: 18px;
      font-weight: 600;
      color: ${props => props.theme.text};
    }
  }

  .close-btn {
    background: transparent;
    border: none;
    color: ${props => props.theme.textSecondary};
    cursor: pointer;
    padding: 8px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;

    &:hover {
      background: ${props => props.theme.hover};
      color: ${props => props.theme.text};
    }

    svg {
      font-size: 20px;
    }
  }
`;

export const DialogBody = styled.div`
  padding: 24px;

  p {
    margin: 0;
    font-size: 15px;
    line-height: 1.6;
    color: ${props => props.theme.textSecondary};
  }
`;

export const DialogFooter = styled.div`
  padding: 16px 24px 24px;
  display: flex;
  gap: 12px;
  justify-content: flex-end;
`;

export const DialogButton = styled.button`
  padding: 10px 24px;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
  display: flex;
  align-items: center;
  gap: 8px;

  ${props => {
    if (props.$variant === 'secondary') {
      return `
        background: transparent;
        color: ${props.theme.textSecondary};
        border: 1px solid ${props.theme.border};

        &:hover {
          background: ${props.theme.hover};
          color: ${props.theme.text};
        }
      `;
    }
    
    if (props.$variant === 'danger') {
      return `
        background: #ef4444;
        color: white;

        &:hover {
          background: #dc2626;
        }

        &:active {
          transform: scale(0.98);
        }
      `;
    }

    if (props.$variant === 'warning') {
      return `
        background: #f59e0b;
        color: white;

        &:hover {
          background: #d97706;
        }

        &:active {
          transform: scale(0.98);
        }
      `;
    }

    return `
      background: #3b82f6;
      color: white;

      &:hover {
        background: #2563eb;
      }

      &:active {
        transform: scale(0.98);
      }
    `;
  }}
`;
